import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'localizedDate',
    pure: false,
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translate: TranslateService,
              @Inject(LOCALE_ID) private _localeId: string) {}

  transform(value: Date | string | number | null | undefined, pattern = 'mediumDate'): string | null {
    const datePipe: DatePipe = new DatePipe(this.translate.currentLang || this._localeId);
    return datePipe.transform(value, pattern);
  }
}
